import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { MY_ACCOUNT_FEATURE } from './my-account-state';
import { reducerProvider, reducerToken } from './reducers';

@NgModule({
  imports: [StoreModule.forFeature(MY_ACCOUNT_FEATURE, reducerToken)],
  providers: [reducerProvider],
})
export class MyAccountStoreModule {}
